import type { HttpError } from "@repo/helpers";
import type { AxiosRequestConfig } from "axios";

import { Delete as HttpDelete, Get as HttpGet, Post as HttpPost, Put as HttpPut } from "@repo/helpers";
import { useCallback } from "react";

import { useUserContext } from "../contexts/userContext";

export function useTLPCloudApi() {
	const { onAuthError } = useUserContext();

	const httpError = useCallback(
		(error: HttpError) => {
			switch (error.status) {
				case 401:
					onAuthError();
					break;
			}
		},
		[onAuthError],
	);

	const Get = useCallback(
		function <TOut>(controller: string, action: string, params: object = {}, config?: AxiosRequestConfig) {
			return HttpGet<TOut>(controller, action, params, config).catchThen(httpError);
		},
		[httpError],
	);
	const Post = useCallback(
		function <TOut, TIn = any>(
			controller: string,
			action: string,
			params: object = {},
			data?: TIn,
			config?: AxiosRequestConfig,
		) {
			return HttpPost<TOut, TIn>(controller, action, params, data, config).catchThen(httpError);
		},
		[httpError],
	);
	const Put = useCallback(
		function <TOut, TIn = any>(
			controller: string,
			action: string,
			params: object = {},
			data?: TIn,
			config?: AxiosRequestConfig,
		) {
			return HttpPut<TOut, TIn>(controller, action, params, data, config).catchThen(httpError);
		},
		[httpError],
	);
	const Delete = useCallback(
		function <TOut>(controller: string, action: string, id: number, config?: AxiosRequestConfig) {
			return HttpDelete<TOut>(controller, action, id, config).catchThen(httpError);
		},
		[httpError],
	);

	return { Get, Post, Put, Delete };
}
